$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

   /// Email Signup

   const $emailSignup = $('.footer .emailSignup');
   $emailSignup.find('.emailSubmitButton').text('SUBSCRIBE');
   $emailSignup.find('.inputFieldTextbox').val('');
   $emailSignup.find('.inputFieldTextbox').attr('src', FULLCLIENTTHEMEPATH + 'images/email-icon.png').attr('placeholder', 'ENTER EMAIL ADDRESS');
   $emailSignup.find('.emailSignupText').html("GET UPDATES!");

   $('.emailInputField').wrap('<div class="email-wrap"></div>');
   $(".emailInputSubmit").appendTo(".email-wrap");
});

$(window).load(function () {
  // ---

});